import { Classes } from "@blueprintjs/core";
import React from "react";

import { DEFAULT_PLAY_PAGE_SIZE } from "../../../redux/constants";
import styles from "./table-skeleton.module.scss";

export const TableSkeleton = () => {
  return (
    <table className={styles.tableSkeleton}>
      <tbody>
        {[...Array(DEFAULT_PLAY_PAGE_SIZE).keys()].map((_item, index) => (
          <tr key={index}>
            <td scope="col">
              <div className={Classes.SKELETON}>Filler Name</div>
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  );
};
